import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import axios from 'axios';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import ArticleThumb from '../../../Components/V2/Category/ArticleThumb';
import SubCategories from '../../../Containers/V2/NewsCategory/SubCategories';
import path from 'path';
import './style.scss';

export default class DetailedNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailed: {},
      hots: [],
      relateds: [],
      latests: [],
    };
  }

  componentDidMount() {
    //call api
    this.getArticle();
    // window.stickySidebar();
  }

  getArticle = () => {
    axios
      .get(`/api/v1/article/${path.basename(window.location.pathname)}`)
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            detailed: data.payload.article,
            relateds: data.payload.related,
            hots: data.payload.hot,
            latests: data.payload.latest,
          });
        }
      });
  };

  render() {
    const { detailed, relateds, hots, latests } = this.state;
    return (
      <CookiesProvider>
        <div className='category-page'>
          <Header />
          <main className='main_content sidebar_right pb-50'>
            <div class='container'>
              <div class='row'>
                <div class='col-lg-8 col-md-12 col-sm-12'>
                  <div class='entry-header entry-header-1 mb-30'>
                    <div class='entry-meta meta-0 font-small mb-15'>
                      <a href='category.html'>
                        <span
                          class='post-cat background2 color-white'
                          style={{
                            backgroundColor: detailed.background_color_category,
                          }}
                        >
                          {detailed.name_category}
                        </span>
                      </a>
                    </div>
                    <h1 class='post-title'>
                      <a href='single.html'>{detailed.title}</a>
                    </h1>
                    <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
                      {/* <span class='post-by'>
                        By <a href='author.html'>Jonh</a>
                      </span> */}
                      <span class='post-on has-dot'>{detailed.scheduled}</span>
                      {/* <span class='time-reading has-dot'>8 mins read</span>
                      <span class='hit-count'>
                        <i class='ti-bolt'></i> 129k Views
                      </span> */}
                    </div>
                    <div class='bt-1 border-color-1 mt-30 mb-30'></div>
                    <div class='single-social-share clearfix '>
                      {/* <div class='entry-meta meta-1 font-small color-grey float-left mt-10'>
                        <span class='hit-count'>
                          <i class='ti-comment mr-5'></i>82 comments
                        </span>
                        <span class='hit-count'>
                          <i class='ti-heart mr-5'></i>68 likes
                        </span>
                        <span class='hit-count'>
                          <i class='ti-star mr-5'></i>8/10
                        </span> 
                      </div> */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <div
                          style={{ marginRight: '5px' }}
                          className='fb-share-button'
                          data-href={window.location.href}
                          data-layout='button_count'
                          data-size='large'
                        >
                          <a
                            rel='noreferrer'
                            target='_blank'
                            href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href};src=SMEdx`}
                            className='fb-xfbml-parse-ignore'
                          >
                            Share
                          </a>
                        </div>
                        <a
                          className='twitter-share-button'
                          href='https://twitter.com/intent/tweet'
                          data-size='large'
                        >
                          Tweet
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <figure class='single-thumnail'>
                    <div class='featured-slider-1 border-radius-5'>
                      <div class='featured-slider-1-items'>
                        <div class='slider-single'>
                          <img
                            src={detailed.thumbnail}
                            alt=''
                            style={{ width: '100%', objectFit: 'cover' }}
                          />
                        </div>
                      </div>
                    </div>
                    <div class='arrow-cover'></div>
                    <div class='credit mt-15 font-small color-grey'>
                      <i class='ti-credit-card mr-5'></i>
                      <span>Image credit: Internet</span>
                    </div>
                  </figure> */}
                  <div class='single-excerpt'>
                    <p class='font-large'>
                      <b>
                        <i>{detailed.short_description}</i>
                      </b>
                    </p>
                  </div>
                  <div class='entry-main-content'>
                    {/* <h2>Design is future</h2> */}
                    <hr class='wp-block-separator is-style-wide' />
                    <article>
                      <div
                        dangerouslySetInnerHTML={{ __html: detailed.content }}
                      />
                    </article>
                  </div>

                  <div class='bt-1 border-color-1 mt-30 mb-30'></div>

                  <div class='related-posts'>
                    <h3 class='mb-30'>Bài cùng chuyên mục</h3>
                    <div class='loop-list container'>
                      <div className='row mb-3'>
                        {relateds.map((item) => (
                          <ArticleThumb key={item.id} item={item} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-lg-4 col-md-12 col-sm-12 primary-sidebar asticky-sidebar'>
                  <div class='widget-area pl-30'>
                    <div class='sidebar-widget widget-social-network mb-50'>
                      <div class='widget-header position-relative mb-20 pb-10'>
                        <h5 class='widget-title mb-10'>Theo dõi SMEdx</h5>
                        <div class='bt-1 border-color-1'></div>
                      </div>
                      <div class='social-network'>
                        <div class='follow-us d-flex align-items-center'>
                          <a
                            class='follow-us-facebook clearfix mr-5 mb-10'
                            href='https://www.facebook.com/SMEdx.vn'
                            target='_blank'
                          >
                            <div class='social-icon'>
                              <i class='ti-facebook mr-5 v-align-space'></i>
                              <i class='ti-facebook mr-5 v-align-space nth-2'></i>
                            </div>
                            <span class='social-name'>Facebook</span>
                          </a>
                          <a
                            class='follow-us-youtube clearfix ml-5 mb-10'
                            href='https://www.youtube.com/watch?v=kWoaWKeSrXw&t=4s&ab_channel=MIMEDIA'
                            target='_blank'
                          >
                            <div class='social-icon'>
                              <i class='ti-youtube mr-5 v-align-space'></i>
                              <i class='ti-youtube mr-5 v-align-space nth-2'></i>
                            </div>
                            <span class='social-name'>Youtube</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class='sidebar-widget widget_alitheme_lastpost mb-50'>
                      <div class='widget-header position-relative mb-20 pb-10'>
                        <h5 class='widget-title mb-10'>Tin mới</h5>
                        <div class='bt-1 border-color-1'></div>
                      </div>
                      <div class='row'>
                        {latests.map((item) => (
                          <div class='col-md-6 col-sm-6 sm-grid-content mb-30'>
                            <div class='post-thumb d-flex border-radius-5 img-hover-scale mb-15'>
                              <a
                                href={`/${
                                  item.is_video_news === 1
                                    ? 'tin-video'
                                    : 'tin-tuc'
                                }/${item.slug}`}
                              >
                                <img src={item.thumbnail} alt='' />
                              </a>
                            </div>
                            <div class='post-content media-body'>
                              <a
                                href={`/${
                                  item.is_video_news === 1
                                    ? 'tin-video'
                                    : 'tin-tuc'
                                }/${item.slug}`}
                              >
                                <h6 class='post-title mb-10 text-limit-2-row'>
                                  {item.title}
                                </h6>
                              </a>
                              <div class='entry-meta meta-1 font-x-small color-grey'>
                                <span class='post-on'>{item.scheduled}</span>
                                {/* <span class='hit-count has-dot'>
                                  126k Views
                                </span> */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div class='sidebar-widget widget_categories mb-50'>
                      <SubCategories />
                    </div>
                    {hots.length > 0 && (
                      <div class='sidebar-widget widget_alitheme_lastpost mb-50'>
                        <div class='widget-header position-relative mb-20 pb-10'>
                          <h5 class='widget-title mb-10'>Tin nổi bật</h5>
                          <div class='bt-1 border-color-1'></div>
                        </div>
                        <div class='post-block-list'>
                          {hots.map((item) => (
                            <a
                              href={`/${
                                item.is_video_news === 1
                                  ? 'tin-video'
                                  : 'tin-tuc'
                              }/${item.slug}`}
                            >
                              <article class='mb-30'>
                                <div class='post-thumb position-relative thumb-overlay mb-30'>
                                  <div
                                    class='img-hover-slide border-radius-5 position-relative'
                                    style={{
                                      backgroundImage: `url(${item.thumbnail})`,
                                    }}
                                  >
                                    <a
                                      class='img-link'
                                      href={`/${
                                        item.is_video_news === 1
                                          ? 'tin-video'
                                          : 'tin-tuc'
                                      }/${item.slug}`}
                                    ></a>
                                    {/* <span class='top-right-icon background8'>
                                  <i class='mdi mdi-camera-alt'></i>
                                </span> */}
                                  </div>
                                </div>
                                <div class='post-content'>
                                  <div class='entry-meta meta-0 font-small mb-15'>
                                    <a href={`/tin-tuc/${item.slug_category}`}>
                                      <span
                                        class='post-cat background9 color-white'
                                        style={{
                                          backgroundColor:
                                            item.background_color_category,
                                        }}
                                      >
                                        {item.name_category}
                                      </span>
                                    </a>
                                  </div>
                                  <h4 class='post-title'>
                                    <a
                                      href={`/${
                                        item.is_video_news === 1
                                          ? 'tin-video'
                                          : 'tin-tuc'
                                      }/${item.slug}`}
                                    >
                                      {item.title}
                                    </a>
                                  </h4>
                                  <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
                                    <span class='post-on'>
                                      {item.scheduled}
                                    </span>
                                    {/* <span class='time-reading has-dot'>
                                  12 mins read
                                </span>
                                <span class='hit-count'>
                                  <i class='ti-bolt'></i> 19k Views
                                </span> */}
                                  </div>
                                </div>
                              </article>
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
